<script lang="ts">
	import { DatePicker } from "@svelte-plugins/datepicker";
	import { createEventDispatcher } from "svelte";
	import clickOutside from "#lib/directives/clickOutside.js";

	interface $$Events {
		change: CustomEvent<{ startDate: number; endDate?: number }>;
	}

	const dispatch = createEventDispatcher();
	export let isOpen = false;
	export let startDate: number | null = null;
	export let endDate: number | null = null;
	export let enableFutureDates = false;
	export let enablePastDates = true;
	export let isRange = true;

	function handleDateChange({ startDate, endDate }: { startDate: number; endDate?: number }) {
		if (startDate) {
			if (isRange && endDate) {
				dispatch("change", { startDate, endDate });
			} else {
				dispatch("change", { startDate });
			}
		}
		isOpen = false;
	}
</script>

<div class="font-medium" use:clickOutside={() => (isOpen = false)}>
	<div role="button" tabindex="0" on:mousedown|stopPropagation on:click|stopPropagation on:keydown|stopPropagation>
		<DatePicker theme="custom-datepicker" bind:isOpen bind:startDate bind:endDate {isRange} includeFont={false} alwaysShow={true} align="right" {enableFutureDates} {enablePastDates} onDateChange={handleDateChange}>
			<slot />
		</DatePicker>
	</div>
</div>

<style>
	:global(.datepicker[data-picker-theme="custom-datepicker"]) {
		--datepicker-calendar-today-background: var(--color-gray-100);
		--datepicker-calendar-today-border: 1px solid var(--color-gray-200);
		--datepicker-calendar-header-text-font-size: 0.875rem;
		--datepicker-calendar-header-text-color: var(--color-gray-900);
		--datepicker-calendar-header-margin: 0;
		--datepicker-calendar-day-font-family: "Inter Variable";
		--datepicker-calendar-day-color: var(--color-gray-900);
		--datepicker-calendar-day-color-hover: #fff;
		--datepicker-calendar-day-background-hover: var(--color-primary-500);
		--datepicker-calendar-range-background: var(--color-primary-400);
		--datepicker-calendar-range-selected-background: var(--color-primary-500);
		--datepicker-calendar-range-included-background: var(--color-primary-500);
		--datepicker-calendar-range-start-end-background: var(--color-primary-500);
		--datepicker-calendar-day-background-hover: var(--color-primary-500);
		--datepicker-calendar-range-start-box-shadow: inset -20px 0 0 var(--color-primary-500);
		--datepicker-calendar-range-start-box-shadow-selected: inset -20px 0 0 var(--color-primary-500);
		--datepicker-calendar-range-end-box-shadow: inset 20px 0 0 var(--color-primary-500);
		--datepicker-calendar-range-end-box-shadow-selected: inset 20px 0 0 var(--color-primary-500);
		--datepicker-calendar-range-included-box-shadow: inset 20px 0 0 var(--color-primary-500);
		--datepicker-calendar-range-included-color: #fff;
		--datepicker-calendar-range-start-end-color: #fff;
		--datepicker-calendar-range-selected-background: var(--color-primary-500);
		--datepicker-calendar-range-color: #fff;
		--datepicker-container-font-family: "Inter Variable";
		--datepicker-container-width: fit-content;
		--datepicker-container-border: 0;
		--datepicker-container-border-radius: 8px;
		--datepicker-container-box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
	}
</style>
